import { Component, Input, OnInit } from '@angular/core';
import { NavController } from '@ionic/angular';
import { UserService } from '../../../services/user.service';
import {BehaviorSubject} from 'rxjs';

@Component({
    selector: 'app-person',
    templateUrl: './person.component.html',
    styleUrls: ['./person.component.scss'],
    standalone: false
})
export class PersonComponent implements OnInit {

  @Input() user;
  public $edit = new BehaviorSubject(false);

  constructor(private navController: NavController,
              private userService: UserService) {
    this.userService.$scopes.subscribe(
      scopes => {
        const ind = scopes.findIndex(s => s.name === 'manager');
        if (ind >= 0) {
          this.$edit.next(true);
        } else {
          this.$edit.next(false);
        }
      }
    );
  }

  ngOnInit() {
  }

  edit() {
    const form = this.userService.createProfileForm();
    this.userService.fillProfileForm(form, this.user.profile);
    this.userService.$editing.next(form);
    this.navController.navigateForward(['people', 'edit', this.user.id]);
  }

  getManagees() {
    if (this.user?.manages?.length) {
      return this.user.manages.map(managee => managee.email).join(', ');
    } else {
      return 'No managees';
    }
  }
}
